<template>
  <div v-if="showDropDown">
    <b-dropdown variant="primary" text="Upgrade Barrel Size" menu-class="pl-0">
      <b-dropdown-item
        v-for="option in barrelOptions"
        :key="option.value"
        @click="
          selectedSize = option;
          setSizeConfirmation();
        "
        >{{ option }}</b-dropdown-item
      >
    </b-dropdown>
    <ConfirmationModal
      :isLoadingConfirmation="loadingConfirmation"
      :isShowDialog="isShowConfirmationModal"
      :btnConfig="buttonConfiguration"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="setSize"
      @eCancel="defaultCancelOperation"
    />
    <SnackbarNotifier
      :isShow="isShowSnackBar"
      :message="responseMessage"
      :snackType="snackbarType"
      :colour="snackBarColour"
      @eReset="resetSnackBar"
    />
  </div>
</template>

<script>
import { error } from "@/services/LoggerService";
import { ApiService } from "@/services/ApiService";
import ConfirmationModal from "@/components/ConfirmationModal.vue";
import ConfirmationModalMixin from "@/mixins/ConfirmationModalMixins";
import SnackbarNotifier from "@/components/SnackbarNotifier.vue";
import SnackbarNotifierMixin from "@/mixins/SnackbarNotifierMixins";
import mixins from "vue-typed-mixins";

export default mixins(SnackbarNotifierMixin, ConfirmationModalMixin).extend({
  name: "UpgradeDropdown",
  props: {
    barrelId: {
      required: true,
      type: String,
    },
    size: {
      required: false,
      type: String,
    },
  },
  components: {
    ConfirmationModal,
    SnackbarNotifier,
  },
  data() {
    return {
      selectedSize: "",
      setting: false,
      barrelOptions: []
    };
  },
  computed: {
    showDropDown(){
      return this.barrelOptions.length > 0
    }
  },
  methods: {
    setSizeConfirmation() {
      if (this.selectedSize != this.size)
        this.showConfirmationModal({
          title: "Upgrade Barrel Size",
          message: `Are you sure you want to upgrade the barrel size to <b><em>${this.selectedSize}</em></b>?`,
        });
    },
    async setSize() {
      try {
        this.setting = true;
        this.startConfirmationLoading();
        let result = await ApiService.Instance.upgradeBarrelSize({
          barrelId: this.barrelId,
          barrelSize: this.selectedSize,
        });
        if (result) {
          this.showNotifier({
            message: `Successfully Upgraded Barrel Size`,
            snackbarType: "success",
          });
          this.$emit("updated");
          this.selectedSize = "";
        }
        this.stopConfirmationLoading();
      } catch (e) {
        this.showNotifier({
          message: `Failed To Upgrade Barrel Size`,
          snackbarType: "error",
        });
        this.stopConfirmationLoading();
        error(e);
      }
      this.setting = false;
    },async retrieveBarrelOptions() {
      const response = await ApiService.Instance.getBarrelOptions();
      const options = response.barrelOptions;
      const barrelOptionsRaw = options.reduce((options, barrelOption) => {
        if ( parseInt(barrelOption.size) > parseInt(this.size)) {
          options.push(barrelOption.size);
        }
        return options;
      }, []);
      this.barrelOptions = barrelOptionsRaw;
    },


  },
  async beforeMount() {
    await this.retrieveBarrelOptions();
  }
});
</script>

<style></style>
